import React, { useState, useEffect } from 'react';
import LandingFooter from '../../components/layouts/LandingFooter';
import AOS from 'aos';
import 'aos/dist/aos.css';

const FAQs: React.FC = () => {
  const [lang] = useState(localStorage.getItem('locale') || 'en');
  const [activeTab, setActiveTab] = useState('pills-home');
  const [query, setQuery] = useState('');

  useEffect(() => {
    AOS.init({ duration: 1000, delay: 300 });
    const urlParams = new URLSearchParams(window.location.search);
    setQuery(urlParams.get('query') || '');
  }, []);

  const highlightText = (text: string) => {
    if (!query) return text;
    const regex = new RegExp(`(${query})`, 'gi');
    return text.replace(regex, '<hl>$1</hl>');
  };

  return (
    <>
      <div className="d-flex flex-column bg-base-light flex-center w-100 min-h-300px z-index-n1 min-h-lg-450px px-9 bg-leaves">
        <img src="/media/lemon.png" className="w-325px lemon-img position-absolute right-0 me-15 z-index-0 img-responsive" alt="" />
        <img src="/media/vegetable.png" className="vegetable-img position-absolute z-index-0 img-responsive" alt="" />
        <form action="" method="get" className="text-end w-75">
          <div className="input-group has-validation w-lg-50 float-end">
            <input
              className="form-control"
              type="search"
              placeholder="Search..."
              name="query"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
            <div className="input-group-addon p-3 z-index-1" style={{ [lang === 'ar' ? 'position' : 'marginLeft']: lang === 'ar' ? 'absolute;left:10px;' : '-3rem' }}>
              <a href="#"><i className="fa fa-search" aria-hidden="true"></i></a>
            </div>
          </div>
        </form>
        <div className="row w-100 mx-auto">
          <div className="col-md-8 mx-auto text-center">
            <div className="mb-5 mb-lg-10 py-10 py-lg-20">
              <h1 className="text-base-dark lh-base fw-bold fs-1x fs-lg-3x mb-5 text-uppercase" data-aos="fade-up">Frequently Asked Questions</h1>
              <br />
              <p className="text-base-dark fs-lg-3" data-aos="fade-up">Find answers to common questions about Fesilah.</p>
              <img src="/media/vegetable2.png" className="w-325px vegetable2-img position-absolute z-index-0 img-responsive" alt="" />
              <img src="/media/tomato.png" className="tomato-img position-absolute right-0 z-index-0 img-responsive" alt="" />
              <br />
            </div>
          </div>
        </div>
      </div>
      <img src="/media/Wave.png" className="w-100 curve" alt="" />
      <div className="mb-n10 mb-lg-n20 z-index-2 min-h-300px inner-box">
        <div className="container">
          <div className="row mt-5">
            <div className="col-12 col-md-10 mx-auto shadow bg-white mb-15 inner-content">
              <div className="row p-lg-15 mt-5 mx-auto">
                <ul className="nav nav-pills d-flex mb-3" id="pills-tab" role="tablist" data-aos="fade-up">
                  <li className="nav-item" role="presentation" style={{ flex: 2 }}>
                    <button
                      className={`nav-link ${activeTab === 'pills-home' ? 'active' : ''} custom-pills fs-lg-3 px-20 py-4 rounded-pill mx-10 w-75`}
                      onClick={() => setActiveTab('pills-home')}
                      type="button"
                    >
                      For Consumer
                    </button>
                  </li>
                  <li className="nav-item" role="presentation" style={{ flex: 2 }}>
                    <button
                      className={`nav-link rounded-pill custom-pills text-base-dark fs-lg-3 py-4 px-20 mx-10 w-75 ${activeTab === 'pills-profile' ? 'active' : ''}`}
                      onClick={() => setActiveTab('pills-profile')}
                      type="button"
                    >
                      For Business
                    </button>
                  </li>
                </ul>
                <div className="tab-content mt-10" id="pills-tabContent" data-aos="zoom-in">
                  <div className={`tab-pane fade ${activeTab === 'pills-home' ? 'show active' : ''}`}>
                    <div className="accordion" id="accordionExample">
                      <div className="accordion-item mt-5 border-0">
                        <h2 className="accordion-header" id="c-1">
                          <button className="accordion-button rounded-pill fs-lg-5 font-bold border-base collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseCOne">
                            What is Fesilah?
                          </button>
                        </h2>
                        <div id="collapseCOne" className="accordion-collapse collapse" aria-labelledby="c1" data-bs-parent="#accordionExample">
                          <div className="accordion-body fs-lg-4 font-light">
                            Fesilah is a comprehensive platform for plant care and agricultural consulting services.
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item mt-5 border-0">
                        <h2 className="accordion-header" id="c2">
                          <button className="accordion-button rounded-pill fs-lg-5 font-bold border-base collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseC2">
                            How can I get help with my plants?
                          </button>
                        </h2>
                        <div id="collapseC2" className="accordion-collapse collapse" aria-labelledby="c2" data-bs-parent="#accordionExample">
                          <div className="accordion-body fs-lg-4 font-light">
                            You can connect with our expert consultants through the Dr. Fesilah feature in the app.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={`tab-pane fade ${activeTab === 'pills-profile' ? 'show active' : ''}`}>
                    <div className="accordion" id="accordionExample2">
                      <div className="accordion-item mt-5 border-0">
                        <h2 className="accordion-header" id="b1">
                          <button className="accordion-button rounded-pill fs-lg-5 font-bold border-base collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseB1">
                            How can businesses partner with Fesilah?
                          </button>
                        </h2>
                        <div id="collapseB1" className="accordion-collapse collapse" aria-labelledby="b1" data-bs-parent="#accordionExample2">
                          <div className="accordion-body fs-lg-4 font-light">
                            Businesses can contact us through our contact form or email for partnership opportunities.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <LandingFooter />
    </>
  );
};

export default FAQs;
















